<template>
    <i class="ico" :class="getClass()" :data-label="label">
        <i :data-icoTarget="valueIco" :data-value="valueText"></i>
    </i>
</template>

<script>
    export default {
        name: 'ui-Ico',
        props: {
            sizeLg: {
                // false: tamaño normal; true: tamaño grande
                type: Boolean,
                default: false,
            },
            disabled: {
                // true: desactivado
                type: Boolean,
                default: false,
            },
            label: String, // etiqueta del icono
            valueIco: String, // nombre del icono
            valueText: String, // icono tipo texto
            classStyles: String, // clases adicionales a incorporar
        },
        methods: {
            getClass: function() {
                var classStyles = '';

                if (this.sizeLg) classStyles = `${classStyles} ico--lg`;
                if (this.disabled) classStyles = `${classStyles} ico--disabled`;
                if (this.classStyles != undefined) classStyles = `${classStyles} ${this.classStyles}`;

                return classStyles;
            },
        },
    };
</script>
